import React, { ReactNode } from "react";

import clsx from "clsx";

import Heading from "components/heading";
import HeroSection from "components/hero-section";

import styles from "./index.module.css";

type TimelineContentProps = {
  title: string;
  description: string;
  link?: string;
  icon: ReactNode;
  offsetFigure?: boolean;
};

const TimelineContent = ({ title, description, link, icon, offsetFigure }: TimelineContentProps) => (
  <HeroSection.Content className={clsx(styles.timelineContent, offsetFigure && styles.offsetFigure)}>
    <HeroSection.Header className="md:items-start md:justify-end md:space-x-0 md:space-y-2">
      <div className={clsx(styles.iconWrapper, "relative max-h-8 w-8 md:w-10 md:max-h-12")}>{icon}</div>
      <Heading tag="h2" className={styles.timelineHeading}>
        {title}
      </Heading>
    </HeroSection.Header>
    <p className={clsx("text-base", styles.timelineDescription)}>{description}</p>
    {link && (
      <HeroSection.Action className="btn-navy" href={link}>
        Learn More
      </HeroSection.Action>
    )}
  </HeroSection.Content>
);

export default TimelineContent;
